type DataEvent = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer: DataEvent[];
  }
}

interface DataLayer {
  isAuthenticated: boolean;
  country: string;
  language: string;
  pageCategory: string;
}

export const pushDataEvent = (data: DataEvent): void => {
  if (
    typeof window !== 'undefined' &&
    typeof window.dataLayer !== 'undefined'
  ) {
    window.dataLayer.push(data);
  }
};

export const pushUserData = ({
  isAuthenticated,
  country,
  language,
  pageCategory,
}: DataLayer) => {
  pushDataEvent({
    authentication: isAuthenticated ? 'Logged in' : 'Anonymous',
    country,
    lang: language,
    pageCategory,
    pageUrl: window.location.href,
  });
};
